import { TrophyContainer } from "./TrophyContainer";
import { GameVars } from "../../GameVars";
import { TrophyState } from "./TrophyState";

export class TrophiesContainer extends Phaser.Group {

    public static currentInstance: TrophiesContainer;

    public sliding: boolean;

    private slidingGroup: Phaser.Group;
    private slidingPositions: number[];
    private slidingIndex: number;
    private trophiesContainersArray: TrophyContainer[];

    private down: boolean;
    private startY: number;
    private endY: number;

    constructor( game: Phaser.Game ) {

        super(game, null, "trophies-container", false);

        TrophiesContainer.currentInstance = this;

        this.sliding = false;
        this.down = false;

        this.slidingGroup = new Phaser.Group(this.game);
        this.add(this.slidingGroup);

        this.slidingPositions = new Array();
        this.trophiesContainersArray = new Array();

        let delta = 0;
        let trophyContainer: TrophyContainer;

        for (let i = 0; i < GameVars.gameData.tournamentData.length; i++) {

            trophyContainer = new TrophyContainer(this.game, GameVars.gameData.tournamentData[i]);
            trophyContainer.y = delta;
            trophyContainer.topPositionSlidingIndex = this.slidingPositions.length;
            this.trophiesContainersArray.push(trophyContainer);

            this.slidingGroup.add(trophyContainer);

            if (GameVars.gameData.tournamentData[i].matchesData.length < 12) {
                this.slidingPositions.push( -trophyContainer.y );
                this.slidingPositions.push( -trophyContainer.y - trophyContainer.containerHeight + 840);
            } else {
                this.slidingPositions.push( -trophyContainer.y );
                this.slidingPositions.push( -trophyContainer.y  - 400);
                this.slidingPositions.push( -trophyContainer.y - trophyContainer.containerHeight + 840);
            }

            delta += trophyContainer.containerHeight;
        }

        this.setContainerInitialPosition();
    }

    public update(): void {

        // iterar en slidingGroup y hacer invisibles los contenedores que esten
        // fuera de la
        if (!GameVars.gameData.introSeen) {
            return;
        }

        if ( this.sliding ) {
            this.checkTrophiesContainerVisibility();
            return;
        }

        // deteccion de toques
        if ( this.game.input.activePointer.isDown ) {

            if (!this.down) {
                this.startY = this.game.input.y;
            }

            this.down = true;

        } else {

            if ( this.down) {

                this.endY = this.game.input.y;

                let lengthSwipe: number = Math.abs(this.startY - this.endY);

                // para que no pille clicks en la zona de los iconos de los trofeos
                if ( lengthSwipe > 150 && this.startY < 815 ) {

                    var downwards: boolean = this.endY > this.startY ? true : false;
                    if (!this.game.device.desktop) {
                        this.onSwipe(downwards);
                    }

                } else {

                    if ( lengthSwipe < 10 && this.startY < 815 ) {
                        this.onClick( this.game.input.x, this.game.input.y);
                    }
                }
            }

            this.down = false;
        }
    }

    public onTeamSelected (teamID: number): void {

        // sacar del slidingIndex el indice del contenedor de trofeos
        let trophyContainerIndex = Math.floor( this.slidingIndex / 2);
        let trophyContainer = <TrophyContainer> this.slidingGroup.getChildAt(trophyContainerIndex);

        // pasarle al contenedor del trofeo correspondiente el teamID para que se los pase al boton
        trophyContainer.teamCursor.onTeamSelected(teamID);
    }

    public onClickIcon( iconIndex: number ): void {

        if ( this.sliding ) {
            return;
        }

        this.sliding = true;

        // sacar del iconIndex el slidingIndex e ir hacia alli
        this.slidingIndex =  this.trophiesContainersArray[iconIndex].getBottomSlidingIndex();

        // calcular el tiempo
        this.game.add.tween(this.slidingGroup)
            .to({y: this.slidingPositions[this.slidingIndex]}, 500, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function (): void {
                this.sliding = false;
            }, this);
    }

    public onSwipe(downwards: boolean): void {

        // comprobar que se puede hacer slide
        if ((this.slidingIndex === this.slidingPositions.length - 1) && !downwards) {
            return;
        }

        if ((this.slidingIndex === 0) && downwards) {
            return;
        }

        let initPos = this.slidingPositions[this.slidingIndex];
        let endPos: number;

        this.sliding = true;

        this.slidingIndex = downwards ?  this.slidingIndex - 1 : this.slidingIndex + 1;
        this.slidingIndex = this.slidingIndex < 0 ? 0 : this.slidingIndex;
        this.slidingIndex = this.slidingIndex > this.slidingPositions.length - 1 ? this.slidingPositions.length - 1 : this.slidingIndex;

        endPos = this.slidingPositions[this.slidingIndex];

        // para que la velocidad de deslizamiento sea constante
        let slidingTime = Math.abs(endPos - initPos) / 2;

        this.game.add.tween(this.slidingGroup)
            .to({y: endPos}, slidingTime, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function (): void {
                this.sliding = false;
            }, this);
    }

    private setContainerInitialPosition(): void {

        let currentTournamentID = GameVars.getAchievedTrophy() - 1;
    
        if (GameVars.tournamentJustUnlocked && GameVars.matchJustUnlocked) {

            currentTournamentID ++;
        } 

        const currentTrophyContainer = this.trophiesContainersArray[currentTournamentID];

        if (currentTrophyContainer) {
            this.slidingIndex = currentTrophyContainer.getSlidingIndex();
        } else {
            // se ha ganado la copa del mundo
            this.slidingIndex = 0;
        }

        this.slidingGroup.y = this.slidingPositions[this.slidingIndex];

        this.checkTrophiesContainerVisibility();
    }

    private checkTrophiesContainerVisibility(): void {

        for (let i = 0; i < this.slidingGroup.length; i++) {
            let trophyContainer: any = this.slidingGroup.getChildAt(i);

            if ( this.slidingGroup.y + trophyContainer.y > 1024
                || this.slidingGroup.y + trophyContainer.y + trophyContainer.containerHeight < 0) {
                trophyContainer.visible = false;
            } else {
                trophyContainer.visible = true;
            }
        }
    }

    private onClick(x: number, y: number): void { 

        // x e y en coordenadas de la pantalla
        if ( TrophyState.currentInstance.matchSelected ||
            x < TrophyContainer.CELL_CLICKABLE_LIMIT_LEFT ||
            x > TrophyContainer.CELL_CLICKABLE_LIMIT_RIGHT || 
            y < TrophyContainer.CELL_CLICKABLE_LIMIT_TOP * GameVars.scaleY) { 

            return;
        }

        let y_s = - this.slidingGroup.y + y; // en el sistema de coordenadas del sliding group

        let i = this.trophiesContainersArray.length;

        while (i--) {
            if (this.trophiesContainersArray[i].topPositionSlidingIndex  <= this.slidingIndex ) {
                break;
            }
        }

        this.trophiesContainersArray[i].onClick (x, y_s);
    }
}
